
import { computed, defineComponent, ref, useStore } from '@nuxtjs/composition-api'
import sortBy from 'lodash/sortBy'
import { mapGetters, mapMutations } from 'vuex'
import { setupTranslationPrefixer } from '~/assets/util'
import { setupGtmFilterStart, setupGtmFilterRemove, setupGtmDateFilterRemove, setupGtmFilterMenuClose, setupGtmDateFilterStart } from '~/assets/composition/setup-gtm'

export default defineComponent({
  props: {
    activeFacets: { type: Array, required: false, default: () => [] },
    facets: { type: Array, required: false, default: () => [] },
    introductionMobile: { type: String, required: true },
    introduction: { type: String, required: true },
    keyword: { type: String, required: false, default: '' },
    showDatePicker: { type: Boolean, required: false, default: false },
    title: { type: String, required: true },
    totalHits: { type: Number, required: true },
    translationGroup: { type: String, required: true },
  },
  emits: ['setKeyword', 'toggleFacet'],
  setup(props) {
    const store = useStore()
    const registerGtmFilterStart = setupGtmFilterStart()
    const registerGtmDateFilterStart = setupGtmDateFilterStart()
    const registerGtmFilterMenuClose = setupGtmFilterMenuClose()
    const registerGtmFilterRemove = setupGtmFilterRemove()
    const registerGtmDateFilterRemove = setupGtmDateFilterRemove()
    const currentlyOpen = ref()
    const closeAll = () => {
      currentlyOpen.value = undefined
    }
    const toggleOpen = (facet) => {
      currentlyOpen.value = facet === currentlyOpen.value ? undefined : facet
    }

    const getState = (active, count) => {
      if (active) {
        return 'active'
      }

      if (count === 0) {
        return 'unavailable'
      }
    }
    const mobileFilters = ref(false)
    const mobileDatePicker = ref(false)
    const toggleMobileFilter = () => {
      store.commit('mobileMenus/toggleMobileFilter')
      mobileFilters.value = store.state.mobileMenus.mobileFilterStatus

      if (store.state.mobileMenus.mobileFilterStatus === true) {
        registerGtmFilterStart()
      } else {
        registerGtmFilterMenuClose()
      }
    }
    const toggleMobileDatePicker = () => {
      store.commit('mobileMenus/toggleMobileFilter')
      mobileDatePicker.value = store.state.mobileMenus.mobileFilterStatus
      if (mobileDatePicker.value === true) {
        registerGtmDateFilterStart()
      }
    }

    const removeFilter = () => {
      registerGtmFilterRemove()
    }

    const removeDateFilter = (date) => {
      registerGtmDateFilterRemove(date)
    }

    // 'tag' facets are displayed differently, hence we separate them from the other `activeFacets`
    const activeTagFacets = computed(() => props.activeFacets.filter(({ facet }) => facet === 'tags'))
    const activeRegularFacets = computed(() => props.activeFacets.filter(({ facet }) => facet !== 'tags'))

    // several flags that determine if we need to show certain blocks
    const hasActiveTagsFacetSelection = computed(() => activeTagFacets.value.length > 0)
    const hasKeywordSelection = computed(() => props.keyword !== '')
    const hasActiveRegularFacetSelection = computed(() => activeRegularFacets.value.length > 0)

    return {
      ...setupTranslationPrefixer('OverviewHeaderAndFilters', props.translationGroup),
      activeRegularFacets,
      activeTagFacets,
      closeAll,
      currentlyOpen,
      getState,
      hasActiveRegularFacetSelection,
      hasKeywordSelection,
      hasActiveTagsFacetSelection,
      mobileDatePicker,
      mobileFilters,
      sortBy,
      toggleMobileDatePicker,
      toggleMobileFilter,
      toggleOpen,
      removeFilter,
      removeDateFilter,
    }
  },
  computed: {
    ...mapGetters({
      date: 'event-overview/date',
      dateIsSpecified: 'event-overview/dateIsSpecified',
    }),
  },
  methods: {
    ...mapMutations({
      setDate: 'event-overview/setDate',
    }),
  },
})
